import { render } from "./ConfigurationRestorePointTabs.vue?vue&type=template&id=f33be9c6&scoped=true"
import script from "./ConfigurationRestorePointTabs.vue?vue&type=script&lang=js"
export * from "./ConfigurationRestorePointTabs.vue?vue&type=script&lang=js"

import "./ConfigurationRestorePointTabs.vue?vue&type=style&index=0&id=f33be9c6&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f33be9c6"]])

export default __exports__
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanels});
